<template>
  <div class="animated fadeIn">
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-5"
        />
      </b-col>
    </b-row>
    <div v-if="!loading">
      <component-header
        title="Update Commission"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="true"
        @back-press="$router.push('/setup/commission')"
      />
      <ValidationObserver v-slot="{ invalid }">
        <b-row>
          <b-col>
            <b-card>
              <b-row>
                <b-col md="4">
                  <label class="label">Commission Rule Name</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Commission Rule Name"
                  >
                    <input
                      type="text"
                      placeholder="Enter Rule Name"
                      class="form-control"
                      v-model="commissionRuleName"
                      required
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>

                <b-col md="4">
                  <label class="label">Commission Rule Type</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Commission Rule Type"
                  >
                    <ebSelect
                      id="commissionRuleType"
                      label="text"
                      v-model="commissionRuleType"
                      :options="commissionRuleTypeOption"
                      :selected="commissionRuleType"
                      placeholder="Select Rule Type"
                    ></ebSelect>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <label class="label">Event Type</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Commission Event Type"
                  >
                    <ebSelect
                      id="eventtype"
                      label="text"
                      v-model="eventtype"
                      :selected="eventtype"
                      :options="eventTypeOption"
                      placeholder="Select event Type"
                    ></ebSelect>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label class="label"> Applicable To </label>
                  <br />
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Commission Applicable To"
                  >
                    <ebSelect
                      id="applicableTo"
                      label="text"
                      v-model="applicableTo"
                      :options="applicableToOption"
                      placeholder="Select Applicable To"
                      :selected="applicableTo"
                    ></ebSelect>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <label class="label"> Applied On </label>
                  <br />
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Commission Applied On"
                  >
                    <ebSelect
                      id="appliedOn"
                      label="text"
                      v-model="appliedon"
                      :options="appliedOnOption"
                      :selected="appliedon"
                      placeholder="Select Applied On"
                    ></ebSelect>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                 <label class="label">Commission value Percentage</label>
                      <!-- <br />
                      <b-form-radio
                        v-model="selected"
                        :aria-describedby="ariaDescribedby"
                        name="some-radios"
                        value="A"
                        >Percentage</b-form-radio
                      >
                      <b-form-radio
                        v-model="selected"
                        :aria-describedby="ariaDescribedby"
                        name="some-radios"
                        value="B"
                        >Amount</b-form-radio
                      > -->

                      <ValidationProvider
                        rules="required|between:0,100"
                        v-slot="{ errors }"
                        name="Commission value Percentage"
                      >
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="`Enter Value`"
                          v-model="commissionValue"
                          required
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                   </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label class="label">Charge Code</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Charge Code"
                  >
                    <input
                      type="text"
                      placeholder="Enter Charge Code"
                      class="form-control"
                      v-model="chargeCode"
                      required
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
            </b-card>
            <div class="text-center mb-3">
              <button
                type="submit"
                @click="submitCommissionRule"
                class="btn btn-primary"
                :disabled="invalid"
              >
                Submit
              </button>
            </div>
          </b-col>
        </b-row>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ebSelect from "@/components/FormElements/Select.vue";
import loader from "@/components/loader/nipigeloader.vue";
import ebButton from "@/components/FormElements/Button";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "CommissionRuleEdit",
  components: {
    ebSelect,
    ebButton,
    loader,
    ValidationProvider,
    ValidationObserver,
    ComponentHeader,
    AtomSpinner,
  },

  data() {
    return {
      loading: false,
      commissionRuleName: "",
      commissionRuleType: "",
      ariaDescribedby: "",
      commissionValue: "",
      eventtype: "",
      appliedon: "",
      chargeCode: "",
      commissionRuleTypeOption: [
        { value: "BASEMENT", text: "Basement" },
        { value: "GROUND", text: "Ground" },
        { value: "ORDER", text: "Order" },
        { value: "ITEM", text: "Item" },
      ],
      applicableTo: "",
      applicableToOption: [
        { value: "PARTNER", text: "Partner" },
        { value: "SELLER", text: "Seller" },
        { value: "DELIVERY_AGENT", text: "Delivery Agent" },
        { value: "DISTRIBUTOR", text: "Distributor" },
      ],
      appliedOnOption: [
        { value: "ORDER_AMOUNT", text: "Order Amount" },
        { value: "PAYMENT", text: "Payment" },
        { value: "INVOICE_AMOUNT", text: "Invoice Amount" },
        { value: "DELIVERY_COST", text: "Delivery Cost" },
      ],
      eventTypeOption: [
        { text: "Order-Fulfilled", value: "ORDER_FULFILLED" },
        { text: "Payment-Success", value: "PAYMENT_SUCCESS" },
        { value: "INVOICE_SUCCESS", text: "Invoice-Success" },
        // { value: "DISTRIBUTOR", text: "Distributor" }
      ],
    };
  },
  computed: {
    ...mapGetters({
      getEditCommissionRule: "commission/GetEditCommissionRule",
    }),
  },
  methods: {
    async submitCommissionRule() {
      let userCommissionRate = this.commissionValue / 100;
      let userInfoData = JSON.parse(sessionStorage.getItem("userLogin"));
      let payloadMain = {
        ruleName: this.commissionRuleName,
        ruleType: this.commissionRuleType.value
          ? this.commissionRuleType.value
          : "",
        chargeCode: this.chargeCode,
        commission: {
          applicableTo: this.applicableTo.value ? this.applicableTo.value : "",
          appliedOn: this.appliedon.value ? this.appliedon.value : "",
          rate: userCommissionRate.toFixed(2),
        },
      };
      let payload = {
        id: this.getEditCommissionRule._id,
        data: payloadMain,
      };

      await this.$store
        .dispatch("commission/updateCommissionRuleAction", payload)
        .then((result) => {
          this.$swal({
            title: "Successfull",
            text: "Commission Rule Updated Successfully!",
            type: "success",
          });
          this.$router.push("/setup/commission");
        })
        .catch((err) => {
          this.$swal({
            title: "Sorry",
            text: "Unable to Update Commission Rule",
            type: "error",
          });
        });
    },
  },
  async mounted() {
    this.loading = true;
    if (this.$route.params && this.$route.params.id) {
      await this.$store.dispatch(
        "commission/editCommissionRuleAction",
        this.$route.params.id
      );
    } else if (!this.$route.params || !this.$route.params.id) {
      this.$router.push("/setup/commission");
    }
    try {
      {
        let ruleObj = this.getEditCommissionRule;
        this.commissionRuleName = ruleObj.ruleName ? ruleObj.ruleName : "";
        this.commissionValue =
          ruleObj.commission.rate * 100 ? ruleObj.commission.rate * 100 : "";
        this.commissionRuleType = {
          value: ruleObj.ruleType ? ruleObj.ruleType : "",
          text: ruleObj.ruleType
            ? ruleObj.ruleType.charAt(0).toUpperCase() +
              ruleObj.ruleType.slice(1).toLowerCase()
            : "",
        };
        (this.chargeCode = ruleObj.chargeCode),
          (this.eventtype = {
            value: ruleObj.eventType ? ruleObj.eventType : "",
            text: ruleObj.eventType
              ? ruleObj.eventType.charAt(0).toUpperCase() +
                ruleObj.eventType.slice(1).toLowerCase()
              : "",
          });
        this.applicableTo = {
          value: ruleObj.commission.applicableTo
            ? ruleObj.commission.applicableTo
            : "",
          text: ruleObj.commission.applicableTo
            ? ruleObj.commission.applicableTo.charAt(0).toUpperCase() +
              ruleObj.commission.applicableTo.slice(1).toLowerCase()
            : "",
        };
        this.appliedon = {
          value: ruleObj.commission.appliedOn
            ? ruleObj.commission.appliedOn
            : "",
          text: ruleObj.commission.appliedOn
            ? ruleObj.commission.appliedOn.charAt(0).toUpperCase() +
              ruleObj.commission.appliedOn.slice(1).toLowerCase()
            : "",
        };
      }
    } catch (err) {}

    this.loading = false;
  },
};
</script>
<style>
.label {
  font-family: "Lato";
  font-weight: bold;
}
</style>
